<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('name')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>角色名称
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('type')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>角色类型
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.type" class="select classification">
                <el-option v-for="item in options_genderType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="source_tr">
          <td class="td_left">
            <span v-if="isMandatory('memo')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>备注
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.memo" class="source"></el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Rolegl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/RoleUpdate'">确定</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Rolegl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/RoleUpdate'">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      form: {
        name: '',
        type: '',
        memo: '',
        glid: '0',
        creator: '1',
        sys: '11'
      },
      options_genderType: [
        {
          value: 1,
          label: '一级审核'
        },
        {
          value: 2,
          label: '二级审核'
        },
        {
          value: 3,
          label: '三级审核'
        },
        {
          value: 4,
          label: '数据发布者'
        },
        {
          value: 5,
          label: '线上云展管理审核'
        },
        {
          value: 6,
          label: '数据编辑'
        },
        {
          value: 7,
          label: '组织角色'
        }
      ],
      //表名
      tabname: 'sysrole',
      //fld表数据
      fldData: []
    }
  },
  async created()
  {
    this.fldData = await window.public.validation(this.tabname)
    this.isgetData()
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 99,
        _minor: 15,
        retAtt: 1,
        name: this.form.name,
        type: this.form.type,
        memo: this.form.memo,
        glid: this.form.glid,
        creator: this.form.creator,
        sys: this.form.sys
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    // 获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/RoleUpdate')
        this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 15,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.name = ret[0].name
        this.form.type = ret[0].type
        this.form.memo = ret[0].memo
        this.form.creator = ret[0].creator
        this.form.sys = ret[0].sys
        this.form.glid = ret[0].glid
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 99,
        _minor: 15,
        retAtt: 1,
        id: this.form.id,
        name: this.form.name,
        type: this.form.type,
        memo: this.form.memo,
        sys: this.form.sys,
        glid: this.form.glid,
        creator: this.form.creator
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/Rolegl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Rolegl'})
      this.$store.commit('onActiveName', '1')
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/RoleAdd.vue